module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "fmhead"
  }, [_c('i', [_vm._v("Acknowledgment")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I would like to thank my husband, Alan, for being the IT guy on this book. As a self-confessed technophobe, I can honestly say he had his work cut out for him from the word go (and then some). Thanks, Big Guy. x x x")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A special thank you to the wonderful people at C&T publishing. They were always there to sort out any queries and keep me on the right track. Their kindness and help made writing this book a very positive experience.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A heartfelt thank you to you all.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg4_1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-689233e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_acknowledgment.vue
// module id = 69
// module chunks = 0